import {h, Component, Fragment} from 'preact';
import PFeed from "../../../services/prematch-feed";

import * as M from "../desktop-templates/prematch-menu.jsx";
import * as I from "../utils/icons.jsx";
import { Trans } from '@lingui/react/macro';

export default class MenuTopleagues extends Component {
    state = {
        topleagues: []
    };

    componentWillMount() {
        PFeed.getMenu((type,data) => {
            if (!!PFeed.mainTournaments) {
                Object.values(data).map(s => {
                    Object.values(s.sub).map(c => {
                        PFeed.mainTournaments.map(tournamentId => {
                            if (!!c.sub[tournamentId]) {
                                this.state.topleagues.push(c.sub[tournamentId]);
                            }
                        });
                    })
                });

                this.setState(this.state);
            }
        });
    }

	clickCallbackFunction(item, callback) {
		if (this.willOpenTournament(item)) {
			this.forceOpenAntepostCompanionTournament(item, callback);
		}
		return callback(item);
	}

	forceOpenAntepostCompanionTournament(tournament, callback) {
		const sportId = '/sport/' + tournament.parent.split('/').slice(2,3).join();
		const categoryId = tournament.parent;
		const category = PFeed.NStorage.get(categoryId);
		if (category == null)
			return;
		const antepostTournament = Object.values(category.sub)
				.find(anotherTournament => (tournament.label + '. Outright') == anotherTournament.label);
		if (antepostTournament == null)
			return;
		if (!this.willOpenTournament(antepostTournament))
			return;
		return this.clickCallbackFunction(antepostTournament, callback);
	}

	willOpenTournament(tournament) {
		return !tournament.selected;
	}

    render({callback}) {
        return !!this.state.topleagues.length && <div class="mb-3 overflow-hidden rounded-xl">
			<M.MenuTitleCentered><Trans>Top Leagues</Trans></M.MenuTitleCentered>
			<div class="px-3 bg-slate-100">
                {this.state.topleagues.map(league => <M.TopLeagueButton onClick={e => !!callback? this.clickCallbackFunction(league, callback) : false}>
					<M.TournamentFlagIcon category={PFeed.NStorage.get(league.parent)} tournament={league} />
					<M.CircleSeparator />
					{/*<M.SportFlagIcon sport={PFeed.getWithParents(league.parent).sport} />*/}
					<M.LeagueNameLabel>{league.name}</M.LeagueNameLabel>
					<I.AngleRight class="h-4 fill-slate-500"></I.AngleRight>
                </M.TopLeagueButton>)}
			</div>
		</div>;
    }
}